import { createRouter, createWebHistory } from "vue-router";
import authGuard from "@/router/authGuard";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    meta: { auth: false, roles: ["administrator"] },
    component: () => import("@/views/SignIn.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/users/Index.vue"),
  },
  {
    path: "/create-user",
    name: "create-user",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/users/createUser.vue"),
  },
  {
    path: "/detail-user",
    name: "detail-user",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/users/detailUser.vue"),
  },
  {
    path: "/lawyer",
    name: "lawyer",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/lawyer/index.vue"),
  },
  {
    path: "/create-lawyer",
    name: "create-lawyer",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/lawyer/create.vue"),
  },
  {
    path: "/detail-lawyer",
    name: "detail-lawyer",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/lawyer/detail.vue"),
  },
  {
    path: "/primary-process",
    name: "primary-process",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/primary_process/index.vue"),
  },
  {
    path: "/create-primary-process",
    name: "create-primary-process",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/primary_process/create.vue"),
  },
  {
    path: "/detail-primary-process",
    name: "detail-primary-process",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/primary_process/detail.vue"),
  },
  {
    path: "/edit-primary-process",
    name: "edit-primary-process",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/primary_process/edit.vue"),
  },
  {
    path: "/testimonials",
    name: "testimonials",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/testimonials/index.vue"),
  },
  {
    path: "/create-testimonials",
    name: "create-testimonials",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/testimonials/create.vue"),
  },
  {
    path: "/jobs",
    name: "jobs",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/job/index.vue"),
  },
  {
    path: "/create-jobs",
    name: "create-jobs",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/job/create.vue"),
  },
  {
    path: "/edit-jobs",
    name: "edit-jobs",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/job/edit.vue"),
  },
  {
    path: "/support",
    name: "support",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/support/index.vue"),
  },
  {
    path: "/support-detail",
    name: "support-detail",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/support/detail.vue"),
  },
  {
    path: "/change-password",
    name: "change-password",
    meta: { auth: true, roles: ["administrator", "agent"] },
    component: () => import("@/views/profile/ChangePassword.vue"),
  },
  {
    path: "/agents",
    name: "agents",
    meta: { auth: true, roles: ["administrator"] },
    component: () => import("@/views/agents/index.vue"),
  },
  {
    path: "/create-agent",
    name: "create-agent",
    meta: { auth: true, roles: ["administrator"] },
    component: () => import("@/views/agents/create.vue"),
  },
  {
    path: "/logs",
    name: "logs",
    meta: { auth: true, roles: ["administrator"] },
    component: () => import("@/views/logs/index.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach(authGuard);
export default router;
